import { Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import SettingNav from '../../../elements/SettingNav';
import BackToLeaseList from '../../../elements/BackToLeaseList';
import ClassesList from '../components/ClassesList';
import { FilterComponent, NoRecordFound, PageLoader, Pagination, STableLoader } from '../../../../shared_elements';
import { globalGetService } from '../../../../utils/globalApiServices';
import { getClasses, getClassesListApi } from '../apiService';
import { checkApiStatus, setGlobalCookie } from '../../../../utils';
import moment from 'moment';
import { displayDateFormatShort } from '../../../../constants';
import { getQbStatusApi } from '../../../quickBooks/apiService';
import { trackActivity } from '../../../../utils/mixpanel';

const ClassesHD = ({ sortInfo, createSortHandler }) => {
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Classes`, page_type: page_type, })
    }
    const tableSorting = (key, name) => (
        <TableSortLabel
            active={sortInfo.sort === key}
            direction={sortInfo.sort === key ? sortInfo.sort_by : 'asc'}
            onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
        >
            {name}
        </TableSortLabel>
    );

    return (
        <TableHead>
            <TableRow>
                <TableCell sx={{ width: 40 }} />
                <TableCell sx={{ minWidth: "100px", whiteSpace: "nowrap" }}>{tableSorting('name', 'Name')}</TableCell>
                <TableCell sx={{ minWidth: "100px", whiteSpace: "nowrap" }}>{tableSorting('company_name', 'Company Name')}</TableCell>
                <TableCell sx={{ minWidth: "90px", whiteSpace: "nowrap" }}>Status</TableCell>
            </TableRow>
        </TableHead>
    )
}

const Classes = () => {
    const [classesInfo, setClassesInfo] = useState({ list: [], pagination: {} });
    const [isLoading, setLoading] = useState(false);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [isQbEnabled, setIsQbEnabled] = useState(null);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [filter, setFilter] = useState({});

    const classesFilterMenu = {
        name: { title: 'Name', inputType: 'text' },
    };

    useEffect(() => {
        globalGetService(getQbStatusApi()).then(response => {
            setSkeletonLoader(true)
            if (checkApiStatus(response)) {
                const enabled = response.data.data?.is_lessor_enabled;
                setIsQbEnabled(enabled);
                if (enabled) getClassesList('skeletonLoader', { per_page: 20 });
            } else {
                setIsQbEnabled(false);
            }
        });
        trackActivity('Page Viewed', { page_title: 'Classes' })
    }, []);

    const getClassesList = (loaderType, query = {}) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getClassesListApi(query)).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                setClassesInfo(response.data.data);
            }
        });
    };

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' };
        } else {
            sortQuery = { ...sortQuery, sort_by: key === 'name' ? 'desc' : 'asc' };
        }
        setSortInfo(sortQuery);
        getClassesList('pageLoader', { ...filter, ...sortQuery, per_page: classesInfo?.pagination?.per_page || 20 });
    };

    const onApplyFilter = (query) => {
        setFilter(query);
        getClassesList('pageLoader', { ...query, page: 1, per_page: classesInfo?.pagination?.per_page || 20 });
    };

    const syncClasses = () => {
        setLoading(true);
        globalGetService(getClasses()).then(response => {
            setLoading(false);
            if (checkApiStatus(response)) {
                setGlobalCookie('thirdPartyClassesState', 'SyncClassesFromQB');
                window.open(response.data.data.url, '_blank');
            }
        });
    };
    if (isQbEnabled === null) return <PageLoader />;

    if (!isQbEnabled) return (
        <div style={{ width: '100vw', height: '100vh', position: 'fixed' }}>
            <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', color: '#000000', textAlign: 'center', margin: '0 auto' }}>
                <br /><br />
                Sorry, You do not have access to the Page.<br />
                Please contact to Acumen for access<br />
                <Link to="/leases">Go Back</Link>
            </div>
        </div>
    );
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Classes`, page_type: page_type, })
    }
    return (
        <Paper className="setting_details_section lease-details-section" elevation={0} sx={{ boxShadow: "0px 0px 2px 1px #BBBBBB" }}>
            {isLoading ? <PageLoader /> : null}
            <SettingNav />
            <div className="lease-details-content" >
                <Paper square className="responsive-paper">
                    <Grid container spacing={1} className="responsive-grid" alignItems='flex-end'>
                        <Grid item size={{ md: 8, xs: 12 }} className="menu-container">
                            <BackToLeaseList />
                            <FilterComponent
                                filter={filter}
                                filterMenu={classesFilterMenu}
                                getResponseBack={onApplyFilter}
                            />
                            <Typography variant="h7" style={{ fontWeight: 'bold', color: '#9439e4', fontSize: '14px' }}> Last Synced by:{" "} <span style={{ fontSize: '12px', fontWeight: 'normal' }}> {classesInfo?.list?.[0]?.qb_last_sync_by?.name ? `${classesInfo.list[0]?.qb_last_sync_by.name} (${classesInfo.list[0]?.last_synced_at ? moment(classesInfo.list[0]?.last_synced_at).format(displayDateFormatShort) : '--'})` : '--'} </span> </Typography>
                        </Grid>
                        <Grid item size={{ md: 4, xs: 12 }}>
                            <ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: '5px' }}>
                                <li className='lease-mobile-button revision-history'>
                                    <Button variant="contained" color="primary" size='small' className='btn-primary' onClick={() => { syncClasses(); handleItemClicked('Sync Classes') }}>Sync Classes</Button>
                                </li>
                            </ul>
                        </Grid>
                    </Grid>
                </Paper>
                <Paper
                    className="lease-detail-table table-container lease-module-paper"
                    elevation={0}
                    sx={classesInfo?.list?.length > 0
                        ? { display: 'flex', flexDirection: 'column', height: 'calc(100vh - 240px) !important', maxHeight: 'calc(100vh - 240px)' }
                        : { display: 'flex', flexDirection: 'column', height: 'auto !important', maxHeight: 'calc(100vh - 240px)' }}
                >
                    <div style={{ flex: classesInfo?.list?.length > 0 ? '1 1 auto' : '0 1 auto', overflow: 'auto', minHeight: 0 }}>
                        {skeletonLoader ? <STableLoader count={2} rowCount={12} /> : (
                            <Table className='mui-table-format' stickyHeader>
                                <ClassesHD sortInfo={sortInfo} createSortHandler={createSortHandler} />
                                <TableBody>
                                    {classesInfo?.list?.length > 0 && classesInfo?.list?.map((item) => (
                                        <ClassesList key={item.id} item={item} />
                                    ))}
                                </TableBody>
                            </Table>
                        )}
                        {!skeletonLoader && classesInfo?.list?.length === 0 && <NoRecordFound />}
                    </div>
                    <Paper square>
                        <Pagination
                            pagination={classesInfo?.pagination}
                            onPageChange={(event, newPage) => { const pageNum = newPage + 1; getClassesList('pageLoader', { ...filter, page: pageNum, per_page: classesInfo?.pagination?.per_page }); }}
                            onRowsPerPageChange={(e) => { const perPage = parseInt(e.target.value, 10); getClassesList('pageLoader', { ...filter, page: 1, per_page: perPage }); }}
                        />
                    </Paper>
                </Paper>
            </div>
        </Paper>
    )
}

export default Classes
